import './Footer.css'

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">
            <svg width="200" height="32" viewBox="0 0 200 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <text x="0" y="24" fill="#FDFBF5" fontFamily="Arial, sans-serif" fontSize="24" fontWeight="bold" textDecoration="underline">Represent</text>
            </svg>
          </div>
          <p className="footer-tagline">
            We help B2B SaaS companies attract more users, increase conversions, and build a strong brand through high-end video content.
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><a href="https://www.representstudio.com/">Home</a></li>
              <li><a href="https://www.representstudio.com/services">Services</a></li>
              <li><a href="https://www.representstudio.com/careers">Careers</a></li>
              <li><a href="https://www.representstudio.com/contact">Contact</a></li>
              <li><a href="https://www.representstudio.com/resources">Resources</a></li>
              <li><a href="https://www.representstudio.com/blog">Blog</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li><a href="https://www.representstudio.com/services/product-launch-videos">Product Launch Videos</a></li>
              <li><a href="https://www.representstudio.com/services/video-editing">Video Editing</a></li>
              <li><a href="https://www.representstudio.com/services/studio-set-up">Studio Set Up</a></li>
              <li><a href="https://www.representstudio.com/services/thought-leadership">Thought Leadership & Case Studies</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="invisible">More Services</h4>
            <ul>
              <li><a href="https://www.representstudio.com/services/youtube-long-form">YouTube Long-Form</a></li>
              <li><a href="https://www.representstudio.com/services/lead-magnet-videos">Lead Magnet Videos</a></li>
              <li><a href="https://www.representstudio.com/services/product-tutorials">Product Tutorials</a></li>
              <li><a href="https://www.representstudio.com/tools/youtube" className="new-badge">
                <span className="badge">new</span> The YouTube Tool
              </a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="copyright">© 2025 Represent Studio. All rights reserved.</p>
          <div className="footer-legal">
            <a href="https://www.representstudio.com/privacy-policy">Privacy Policy</a>
            <a href="https://www.representstudio.com/terms-conditions">Terms & Conditions</a>
            <a href="https://www.representstudio.com/pricing-disclosure">Pricing Disclosure</a>
          </div>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/representstudio/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@representstudio" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
